// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1iUSi","title":"Images45_title__kp0HL","images":"Images45_images__2bxVg"};